import { Grid } from "@mui/material";
import PriceSettingsCard from "./PriceSettingsCard";

const GlobalSettingsPage = () => {
  return (
    <Grid
      container
      spacing={2}
      sx={{
        marginTop: 1,
        marginBottom: 1,
        paddingLeft: 1,
        paddingRight: 1,
      }}
    >
      <Grid size={{ xs: 12, lg: 6 }} data-testid="prices">
        <PriceSettingsCard />
      </Grid>
    </Grid>
  );
};

export default GlobalSettingsPage;
